import { useCallback, useContext } from 'react';

import { ActivityForm, PaymentMethods } from './components';

import {
  QuotationInfoContext,
} from '../../../../../shared/contexts';

import {
  QUOTATION_BUTTON,
  QuotationStep,
} from '../../../../../shared/interfaces';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { SummarySection } from '../../../../../shared/components/SummarySection';

import { QuotationStepButtons } from '../../../../../shared';

import './index.css';

export const Quotation = () => {
  const { setCurrentStep } = useContext(QuotationInfoContext);
  
  const {
    labelButton,
    quotationResponse,
    reQuotationResponse,
    setLabelButton,
    handlerOnClick
  } = useContext(StepThreeFormContext);

  const onPressBackButton = useCallback(() => {
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
  }, [setCurrentStep, setLabelButton, quotationResponse]);

  return (
    <>
      <ActivityForm />

      {quotationResponse && (
        <>
          <PaymentMethods />
          <SummarySection
            labelButton={labelButton}
            quotationResponse={quotationResponse}
            reQuotationResponse={reQuotationResponse}
          />
        </>
      )}

      <QuotationStepButtons
        onClick={handlerOnClick}
        label={labelButton}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
